export default __webpack_public_path__ + "static/media/hihatclosed.ae3393af.mp3";